export default __webpack_public_path__ + "_/_/libs/common/src/assets/img/upside_down.png";